<template>
    <v-card>
        <v-card-title>
                <div class="headline">Definições do curso</div>
        </v-card-title>        
        <v-card-text v-if="coordinatedCourses && coordinatedCourses.length > 0">
            <v-layout wrap>
                <v-flex xs12 sm5>
                    <v-select
                        append-icon="class"
                        label="Curso"
                        v-model="course"
                        :disabled="coordinatedCourses.length < 2"
                        :items="coordinatedCourses" item-text="name" item-value="id"></v-select></v-flex>                
                <v-flex xs12 sm5 offset-sm1>
                    <v-select
                        append-icon="date_range"
                        label="Semestre"
                        v-model="semester"
                        :items="semesters" item-text="name" item-value="id"></v-select></v-flex>                   
                <v-flex xs12 sm4>
                    <v-menu 
                        lazy  
                        :close-on-content-click="false"
                        v-model="menuEnrollmentStartDate"
                        transition="v-scale-transition" offset-y :nudge-left="40"
                        full-width>
                        <v-text-field 
                            label="Publicação e inscrição de ouvintes" 
                            hint="A partir desta data as bancas do curso no semestre informado estarão disponíveis para consulta pública e inscrição de ouvintes (alunos, professores e público externo)"
                            persistent-hint
                            v-model="formattedEnrollmentStartDate"                            
                            append-icon="date_range" 
                            slot="activator"></v-text-field>
                        <v-date-picker 
                            v-model="configs.enrollmentStartDate" 
                            no-title 
                            scrollable 
                            actions
                            locale="pt-BR">
                            <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Cancelar</v-btn>
                                    <v-btn flat color="success" @click="submitConfig('enrollmentStartDate', save)">Salvar</v-btn>
                                </v-card-actions>
                            </template>                            
                        </v-date-picker>                    
                      </v-menu>                                            
                </v-flex>
                <v-alert :value="true" color="error" v-if="error">{{ error }}</v-alert>
            </v-layout>
        </v-card-text>   
        <v-card-text v-if="!loadingCourses && (!coordinatedCourses || coordinatedCourses.length == 0)">
            <v-alert :value="true" color="error">As definições de curso só podem ser configuradas pelo coordenador</v-alert>
        </v-card-text>         
    </v-card>        
</template>

<script>
    import auth from './../auth'
    import moment from 'moment'

    export default {
        name: 'CourseConfigs',
        data() {
            return {
                courses: [],
                loadingCourses: true,
                course: '',                
                semester: '',
                configs: {
                    enrollmentStartDate: ''
                },
                menuEnrollmentStartDate: false,
                error: null
            }
        },
        computed: {
            coordinatedCoursesId() {
                let courses = []
                if (auth.user.courses_coordinator) {
                    courses = courses.concat(auth.user.courses_coordinator)
                }
                if (auth.user.courses_exam_coordinator) {
                    courses = courses.concat(auth.user.courses_exam_coordinator)
                }
                return courses
            },
            coordinatedCourses() {
                if (auth.user.roles.includes('admin')) return this.courses
                let courses = []
                for (let course of this.courses) {
                    if (this.coordinatedCoursesId.includes(course.id)) {
                        courses.push(course)
                    }
                }
                return courses
            },
            semesters() {
                let semesters = [ { id: '20172', name: '2017.2'} ],
                    currentYear = new Date().getFullYear(),
                    currentSemester = new Date().getMonth() <= 6 ? 1 : 2
                for (let year = 2018; year <= currentYear; year++) {
                    semesters.push({ id: year + '1', name: year + '.1'})
                    if (year < currentYear || currentSemester == 2) {
                        semesters.push({ id: year + '2', name: year + '.2'})
                    }
                }
                semesters.reverse()
                return semesters
            },
            currentSemester: function () {
                let currentYear = new Date().getFullYear(),
                    currentSemester = new Date().getMonth() <= 6 ? 1 : 2
                return currentYear + '' + currentSemester
            },            
            formattedEnrollmentStartDate() {
                if (!this.configs.enrollmentStartDate) return ''
                return moment(this.configs.enrollmentStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
            }
        },
        methods: {
            loadConfigs() {
                this.$http.post('courseSettings', { course: this.course, semester: this.semester }).then(response => {
                    if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                        for (let key in response.data.configs) {                            
                            this.configs[key] = response.data.configs[key].value
                        }
                    } else {                     
                        this.error = 'Não foi possível buscar as definições do curso'
                        console.log('Erro ao buscar definições do curso')
                    }                    
                }, response => {
                    if (response.data && typeof response.data.errors !== 'undefined') {
                        this.error = response.data.errors.join('; ')
                    } else {
                        this.error = 'Não foi possível buscar as definições do curso'
                    }
                    console.log('Erro ao buscar definições do curso')
                })  
            },
            submitConfig(key, callback) {
                let value = this.configs[key],
                    params = {
                        course: this.course,
                        semester: this.semester,
                        key: key,
                        value: value
                    }
                this.error = null
                this.$http.put('courseSettings', params).then(response => {
                    if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                        callback()
                    } else {                     
                        console.log('Erro ao alterar definição do curso')
                    }
                }, response => {
                    if (response.data && typeof response.data.errors !== 'undefined') {
                        this.error = response.data.errors.join('; ')
                    }
                    console.log('Erro ao alterar configuração do curso')
                })                                   
            }
        },
        watch: {
            course() {
                this.loadConfigs()
            },
            semester() {
                this.loadConfigs()
            }
        },        
        created: function () {
            // Load courses
            this.$http.get('courses').then(response => {
                this.courses = response.body     
                this.loadingCourses = false          
            }, response => {
                this.loadingCourses = false
                console.error('Erro ao buscar relação de cursos.')
                console.debug(response)                
            });          
            // Default semester  
            if (!this.semester) {
                this.semester = this.currentSemester
            }
            if (!this.course) {
                if (auth.user.courses_exam_coordinator) {
                    this.course = auth.user.courses_exam_coordinator[0]
                } else if (auth.user.courses_coordinator) {
                    this.course = auth.user.courses_coordinator[0]
                }
            }
            this.loadConfigs()             
        }        

    }

</script>


// WEBPACK FOOTER //
// CourseConfigs.vue?312c5314